import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { enumHtsChatMessageRole } from '@data-layer/enums/common';

/** One chat bubble: classifier on the left, user on the right (#13383). */
@Component({
  selector: 'app-hts-assistant-message',
  templateUrl: './hts-assistant-message.component.html',
  styleUrls: ['./hts-assistant-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HtsAssistantMessageComponent {
  @Input() public role: enumHtsChatMessageRole;
  @Input() public content: string;
  /** Do-over history: part of a superseded conversation. */
  @Input() public isDimmed: boolean = false;

  public get isUser(): boolean {
    return this.role === enumHtsChatMessageRole.User;
  }
}
